/**
 * @name 检验是否是全中文
 */
const isChinese = (str) => {
    const reg = /^[\u4e00-\u9fa5]+$/i;
    if (!reg.test(str)) {
        return false;
    } else {
        return true;
    }
}

/**
 * @name 检验8到16位数字与密码组合的密码
 */
const isCombinationPassword8to16 = (str) => {
    const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
    if (!reg.test(str)) {
        return false;
    } else {
        return true;
    }
}

/**
 * @name 正则手机格式校验
 */
const isPhoneNumber = (str) => {
    const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    if (!reg.test(str)) {
        return false;
    } else {
        return true;
    }
}

/**
 * @name 正则邮箱格式校验
 */
const isEmail = (str) => {
    const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    if (!reg.test(str)) {
        return false;
    } else {
        return true;
    }
}

/**
 * @name 是否为空
 */
const isEmpty = (str) => {
    if (str) {
        return false
    } else {
        return true
    }
}

function isJsonString(str) {
    try {
        const toObj = JSON.parse(str) // json字符串转对象
        /*
            判断条件 1. 排除null可能性 
                     2. 确保数据是对象或数组
        */
        if (toObj && typeof toObj === 'object') {
            return true
        }
    } catch {}
    return false
}

// 获取string
function getString(str) {
    if (typeof str == 'string') {
        try {
            return JSON.parse(str)
        } catch (e) {
            return str
        }
    }
    return str
}

export {
    isChinese,
    isCombinationPassword8to16,
    isPhoneNumber,
    isEmpty,
    isEmail,
    isJsonString,
    getString
}